import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;
const API_URL = import.meta.env.VITE_API_URL;

const LOGIN_HEADERS = {headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=ISO-8859-1'}};
const FORM_URLENCODED = {headers: {'Content-Type': 'application/x-www-form-urlencoded'}};

const LoginService = {
    getLoginInfo: async () => axios.get(API_URL + "/get/login/info")
        .then(({data}) => data).catch((err) => { throw err }),

    login: async (data) => axios.post(API_KEEPER + "/login", data, LOGIN_HEADERS)
        .then(({data}) => data).catch((err) => { throw err }),

    verifyUser: async (formData) => axios.post(API_KEEPER + "/password-manager/user/verify", formData)
        .then(({data}) => data).catch((err) => { throw err }),

    passwordRecovery: async (formData) => axios.post(API_KEEPER + "/password-manager/user/password-recovery", formData)
        .then(({data}) => data).catch((err) => { throw err }),

    setPassword: async (formData) => axios.post(API_KEEPER + "/password-manager/user/set-password", formData)
        .then(({data}) => data).catch((err) => { throw err }),

    changePasswordAfterLogin: async (formData) => axios.post(API_KEEPER + "/password-manager/user/change-password-after-login", formData)
        .then(({data}) => data).catch((err) => { throw err }),

    twoFactorStart: async (data) => axios.post(API_KEEPER + "/open/two-factor/start", data, FORM_URLENCODED)
        .then(({data}) => data).catch((err) => { throw err }),

    logout: async () => axios.post(API_KEEPER + "/logout").catch((err) => { throw err }),

    generateTokenHash: async (uuid) => axios.post(API_KEEPER + "/generateTokenHash", {uuid}).then(({data}) => data).catch((err) => { throw err }),
};

export default LoginService;